import { render, staticRenderFns } from "./ServiceTypeList.vue?vue&type=template&id=d45513a6"
import script from "./ServiceTypeList.vue?vue&type=script&lang=js"
export * from "./ServiceTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports